import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ReactCSSTransitionGroup from 'react-transition-group'; // ES6
import CuentaRegresiva from "./cuentaregresiva";

const Home = () => {
  const [showtransition, setShowTransition] = useState(false);

  useEffect(() => {
    // setShowTransition(true)
  })

  return (
    <>
      <Grid container justifyContent='center'>
        <Grid item xs={12}>
          <img src="/images/texto.png" style={{ width: "100%" }} alt="texto" />
        </Grid>
        <Grid item xs={12}>
          <Stack direction='row' justifyContent='center'>
            <img src="/images/proceso_inscripcion.jpg" style={{ width: "83%" }} alt="proceso" />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: '50px' }}>
          <Stack direction='row' justifyContent='center' spacing={3}>
            <img src="/images/instrucciones/fechas_recepcion.jpg" style={{ width: "40%" }} alt="recepcion" />
            <img src="/images/instrucciones/tarifas.jpg" style={{ width: "40%" }} alt="tarifas" />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: '50px' }}>
          <Stack direction='row' justifyContent='center' spacing={3}>
            <img src="/images/giras/gira_doka_estate.jpg" style={{ width: "40%" }} alt="recepcion" />
            <img src="/images/giras/gira_san_lucas.jpg" style={{ width: "40%" }} alt="tarifas" />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: '50px' }}>
          <Stack direction='row' justifyContent='center' spacing={3}>
            <img src="/images/cena/cena_tica_1.jpg" style={{ width: "40%" }} alt="recepcion" />
            <img src="/images/cena/cena_tica_2.jpg" style={{ width: "40%" }} alt="tarifas" />
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: '30px' }}>
          <img src="/images/mapa.jpg" style={{ width: "100%" }} alt="mapa" />
        </Grid>
        <Grid item xs={12} sx={{ mt: '50px' }}>
          <img src="/images/cfp.jpg" style={{ width: "100%" }} alt="papers" />
        </Grid>
        <Grid item>
          <CuentaRegresiva />
        </Grid>
      </Grid>
    </>
  );
};

export default Home;
